import { useState, type ReactNode } from 'react';

import Text from '@cartwhl/ui/base/Text';

import { PANEL_WRITING_CLASSNAME } from '../../../presentations/panelWritingStyle';

interface SectionProps {
  title: string;
  defaultOpen?: boolean;
  headerActions?: ReactNode;
  children: ReactNode;
}

export default function Section({
  title,
  defaultOpen = true,
  headerActions,
  children,
}: SectionProps) {
  const [open, setOpen] = useState(defaultOpen);
  return (
    <div className="border-gray-30/70 dark:border-gray-60/70 border-b last:border-b-0">
      <div className="bg-gray-15/45 dark:bg-gray-75/85 flex items-center gap-1 rounded-lg px-3 py-1">
        <button
          type="button"
          className="hover:bg-gray-15 dark:hover:bg-gray-75 flex min-w-0 flex-1 items-center gap-1 rounded-md py-0.5 text-left transition-colors"
          onClick={() => setOpen((o) => !o)}
        >
          <span
            className={`text-gray-45 inline-block transition-transform ${open ? 'rotate-90' : ''}`}
          >
            ▸
          </span>
          <Text variant="studio/body/medium/xs" className={PANEL_WRITING_CLASSNAME}>
            {title}
          </Text>
        </button>
        {headerActions && (
          <div className="shrink-0" onClick={(e) => e.stopPropagation()}>
            {headerActions}
          </div>
        )}
      </div>
      {open && <div className="px-3 pb-3">{children}</div>}
    </div>
  );
}
